/**
 * Custom ImageShowComponent - Override Component
 * Auto generated overrides from shared library
 */
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'image-show',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-show.html',
  styleUrl: './image-show.css'
})
export class ImageShow implements OnInit {
  @Input() data: any;
  imageSrc = '';

  private get imageConfig(): any {
    return this.data?.data ?? this.data ?? {};
  }

  get titleText(): string {
    const cfg = this.imageConfig;
    return String(cfg?.title ?? cfg?.text ?? '').trim();
  }

  get bodyText(): string {
    const cfg = this.imageConfig;
    return String(cfg?.description ?? cfg?.subText ?? cfg?.caption ?? '').trim();
  }

  ngOnInit(): void {
    this.imageSrc = this.resolveImagePath();
  }

  private resolveImagePath(): string {
    const cfg = this.imageConfig;
    const rawPath = String(
      cfg?.imagePath ??
      cfg?.src ??
      cfg?.imageUrl ??
      cfg?.path ??
      '',
    ).trim();

    if (!rawPath) return '';

    if (
      rawPath.startsWith('/') ||
      /^https?:\/\//i.test(rawPath) ||
      rawPath.startsWith('data:')
    ) {
      return rawPath;
    }

    if (rawPath.startsWith('./assets/')) {
      return `/${rawPath.substring(2)}`;
    }
    if (rawPath.startsWith('assets/')) {
      return `/${rawPath}`;
    }

    return rawPath;
  }

  get altText(): string {
    const cfg = this.imageConfig;
    return String(cfg?.alt ?? cfg?.title ?? 'image').trim();
  }

  get showImage(): boolean {
    const cfg = this.imageConfig;
    if (!this.imageSrc) {
      return false;
    }
    if (cfg?.showImage === false) {
      return false;
    }
    return true;
  }

  get htmlContent(): string {
    const cfg = this.imageConfig;
    return String(cfg?.html ?? '').trim();
  }

  get imageText(): string {
    const cfg = this.imageConfig;
    return String(cfg?.imageText ?? '').trim();
  }

  get jsonText(): string {
    const cfg = this.imageConfig;
    const val = cfg?.text;
    if (val == null) {
      return '';
    }
    if (typeof val === 'string') {
      return val.trim();
    }
    try {
      return JSON.stringify(val, null, 2);
    } catch {
      return String(val);
    }
  }

  get content(): any {
    const cfg = this.imageConfig;
    return cfg?.content;
  }

  isComplexItem(item: any): boolean {
    return item && typeof item === 'object' && item.bold != null;
  }

}
